
import React from "react"
import { StyleSheet } from "~/ui/primitives"
import { observer } from "mobx-react-lite"
import styled from '~/ui/styled'
import { CenterFlex, ColumnFlex, Flex, IconFont } from "~components/El"
import { Avatar } from "~widgets/avatar"
import { OvalBadge } from "~widgets/badge"
import Icon from "~widgets/icon"
import { MessagePreview } from "~widgets/message-preview"
import { MessageStatus, MessageTime } from "~widgets/message"
import { useTheme } from '~/ui/styled'
import ChatTitle from "./chat-title"
import { useStores } from "~models"
import { ChatListItemCoreProps } from "../types"
// import { Text } from "~components"
const Container = styled(Flex)`
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-left: 12px;
  /* padding: 10px 12px; */
`

const Main = styled(ColumnFlex)`
  position: relative;
  flex: 1;
  height: 68px;
  width: 100%;
  padding: 15px 0;
  margin-left: 12px;
  margin-right: 12px;
  border-bottom-width: ${StyleSheet.hairlineWidth}px;
  border-bottom-color: ${({ theme }) => theme.colors.border};
  border-bottom-style: solid;
`

const Row = styled(Flex)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

const RightWrap = styled(Flex)`
  flex-direction: row;
  align-items:center;
  justify-content: space-between;
  gap: 4px;
  width:auto;
  min-width: max-content;
`

const MuteUnreadDot = styled.div`
  position: absolute;
  top: -6px;
  right: -6px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.danger};
  border: 1px solid #fff;
  z-index: 1;
`
const ChatListItemCore: React.FC<ChatListItemCoreProps> = ({ item }) => {
  
  const theme = useTheme()
  const { contactStore } = useStores()
  const contact = item.receiver?.id ? contactStore.byUserId(item.receiver.id) : null
  const isMute = (() => {
    if (contact) {
      return contact.is_mute
    } else {
      return item.is_mute
    }
  })()
  
  return (
    <Container theme={theme}>
      <CenterFlex position="relative" width='auto'>
        {item.messageUnreadCount > 0 &&
          (isMute ? (
            <MuteUnreadDot />
          ) : (
            <OvalBadge
              value={item.messageUnreadCount > 100 ? "99+" : item.messageUnreadCount}
              top="-8px"
              right="-8px"
            />
          ))}
        <Avatar  size={48} avatar={item.displayImage} name={item.displayTitle} />
        {item.chatTypeEnum === "CHANNEL" && (
          <CenterFlex
            position="absolute"
            right="0"
            bottom="0"
            width="18px"
            height="18px"
            borderRadius="9px"
            bg={theme.colors.purpleBackground}
          >
            <IconFont name="pdbs" size={8} color={theme.colors.textLight} />
          </CenterFlex>
        )}
        {item.chatTypeEnum === "GROUP" && (
          <CenterFlex
            position="absolute"
            right="0"
            bottom="0"
            width="18px"
            height="18px"
            borderRadius="9px"
            bg={theme.colors.primary}
          >
            <IconFont name="qbs" size={8} color={theme.colors.textLight} />
          </CenterFlex>
        )}
      </CenterFlex>
      <Main>
        <Row height='auto'>
          <ChatTitle
            title={item.displayTitle}
            chatTypeEnum={item.chatTypeEnum}
            count={0}
            isMute={isMute}
          />
          <RightWrap>
            {item.lastMessage && <MessageStatus message={item.lastMessage} />}
            {item.lastMessage && <MessageTime time={item.lastMessage.created} />}
            {item.pinTime && <Icon name="pin" color={theme.colors.success} size={16} />}
          </RightWrap>
        </Row>
        {item.lastMessage && (
          <MessagePreview
            draft={item.draft}
            message={item.lastMessage}
            chatTypeEnum={item.chatTypeEnum}
            isUnread={item.messageUnreadCount !== 0}
          />
        )}
      </Main>
    </Container>
  )
}

export default observer(ChatListItemCore)
